import { render } from "./App.vue?vue&type=template&id=58a01b60"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=58a01b60&lang=css"

import exportComponent from "C:\\workspace\\vue\\bxt4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__